import $ from 'jquery';
import { gsap, TweenMax, SteppedEase } from "gsap";
 
class BannerPulserItem {
    constructor(el, i) {

        this.render(el);
    }

    pulse() {
        var tl = new gsap.timeline({ repeat: -1 });
        //   tl.set(this.drips, { transformOrigin: 'center center', rotate: '180deg', y:3 });

        tl.add(TweenMax.to(this.tail, 0.5, { transformOrigin: 'center top', scaleY: 1.05, yoyo: true, repeat: 1 }));
        tl.add(TweenMax.to(this.arrowHead, 0.5, {  y: '5%', yoyo: true, repeat: 1 }, ">-0.5"))
       
    }


    pulsar_CLICK(e) {
        $('html, body').animate({
            scrollTop: this.target.offset().top  - 100
        }, 750);
    }

    render(el) {
        this.el = $(el);
        this.target = this.el.parents('.c-banner').next();
 
        this.tail = $('*[data-ref="arrow-head"]');
        this.arrowHead = $('*[data-ref="tail"]');
 
        this.el.on('click', this.pulsar_CLICK.bind(this));
        this.pulse();
    }
    

}

class BannerPulser {
    constructor(selector, element) {
        this.all = element.querySelectorAll(selector);
        for (var i = 0; i < this.all.length; i++) {
            this.render(this.all[i], i);
        }
    }

    render(el, index) { 
        new BannerPulserItem(el, index);
    }
}

export default BannerPulser;
